import { ViewCategory } from '@ddt-web/config';

import { ReportDcrDefaults } from '../config/report-dcr-defaults';

export class ReportUtils {
	public static createDcrKeyPrefixForPdf(text: string): string {
		return (
			'PDF_' +
			text
				.replace(/[ -]/g, '_')
				.replace(/_+/g, '_')
				.toUpperCase() +
			'_'
		);
	}

	public static isPsReport(viewCategory: ViewCategory): boolean {
		return viewCategory === ViewCategory.FA_PLUS_PDF;
	}

	public static convertCustomPageSizeForPdf(customPageSvg: string, widthPx: string, heightPx: string): string {
		const svg: HTMLDocument = new DOMParser().parseFromString(customPageSvg, 'text/html');
		svg.body.getElementsByTagName('svg')[0].setAttribute('height', heightPx);
		svg.body.getElementsByTagName('svg')[0].setAttribute('width', widthPx);
		return svg.body.innerHTML;
	}

	/**
	 * Gets default DCR values for DCR keys that are replaced by the Replacer class in the AchoReportComposerService
	 * These DCR keys will be used as default values when replacing keys of the format $key$
	 * 
	 * @param dcrKeys 
	 */
	public static getDcrDefaults(dcrKeys: Array<string>): Object {
		if (!dcrKeys) {
			return new Object();
		}

		return dcrKeys.reduce((defaultsMap, dcrKey) => {
			defaultsMap[dcrKey] = ReportDcrDefaults[dcrKey];
			return defaultsMap;
		}, new Object());
	}

	public static parseSvgElement(page: SVGElement): string {
		const parser = new DOMParser();
		const doc = parser.parseFromString('<svg></svg>', 'text/xml');
		doc.removeChild(doc.firstChild);
		doc.appendChild(page);
		const xmlString = new XMLSerializer().serializeToString(doc);
		return xmlString.replace(/ xmlns="" /g, ' ');
	}
}
